import { useQuery } from '@tanstack/react-query'
import { ShipmentReadinessOverviewApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

/**
 * 出荷判定PoCの埋め込みダッシュボードURLを取得するカスタムフック
 */
export const useQueryShipmentReadinessOverviewUrl = () => {
  return useQuery({
    queryKey: queryKeys.url,
    queryFn: () =>
      baseClient
        .getApi(ShipmentReadinessOverviewApi)
        .getShipmentReadinessOverviewUrl(),
    select: data => data.url,
  })
}
